var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosFerlabColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 20,
    viewBox: "0 0 175 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_757_1276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3119 1.06909H5.95337V3.51898H17.3119V1.06909Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6705 6.85962H17.3119V9.30951H28.6705V6.85962Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9667 10.8687H0.608154V13.3185H11.9667V10.8687Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3253 16.6592H11.9667V19.1091H23.3253V16.6592Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1917 19.9998V0.26709H59.6282V2.89515H45.8197V19.9998H43.1917ZM48.3587 11.492V9.04214H58.8264V11.492H48.3587Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3008 19.9998V0.26709H79.6282V2.89515H64.9288V17.3718H79.6282V19.9998H62.3008ZM67.4678 11.1802V8.73034H78.8709V11.1802H67.4678Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.9 19.9998L96.6883 14.4319H88.0469V11.982H96.8665C99.7618 11.982 101.187 10.3784 101.187 7.34949C101.187 4.32054 99.5837 2.9397 96.8665 2.9397H85.5079V20.0444H82.8799V0.26709H96.8665C101.232 0.26709 103.815 3.02878 103.815 7.30495C103.815 10.6012 102.301 12.962 99.6728 13.9419L105.686 19.9998H101.9V19.9998Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.735 19.9998V0.26709H110.363V17.3718H124.127V19.9998H107.735Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.958 19.9999L144.795 14.6992H134.417L135.708 12.4275H143.414L138.247 3.69699L128.581 19.9999H125.552L137.045 0.890759C137.356 0.356238 137.757 0.0444336 138.336 0.0444336C138.916 0.0444336 139.272 0.356238 139.628 0.890759L151.12 19.9999H147.958V19.9999Z",
    fill: "#01617E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.526 0.26709H167.869C171.566 0.26709 174.016 2.00428 174.016 5.3005C174.016 7.88402 172.635 9.22032 170.809 9.62121C172.902 10.1557 174.328 11.7593 174.328 14.2983C174.328 17.5945 172.011 19.9553 168.181 19.9553H153.526V0.26709ZM156.154 2.89515V17.3718H166.933C169.65 17.3718 171.699 16.3473 171.699 14.2537C171.699 12.2938 170.363 11.1802 168.002 11.1802H158.693V8.73034H167.824C170.23 8.73034 171.343 8.01765 171.343 5.83502C171.343 3.51876 169.65 2.89515 166.8 2.89515H156.154V2.89515Z",
    fill: "#01617E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_757_1276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.254,
    height: 20,
    fill: "white",
    transform: "translate(0.608154)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFerlabColor);
export default __webpack_public_path__ + "static/media/logos-ferlab-color.d7e102f43ac553ddf9d367f43a501485.svg";
export { ForwardRef as ReactComponent };